import { useEffect, useState } from 'react';
import { integrationApi, type SmtpConfig } from '../../../api';

export default function SettingsSmtp() {
  const [form, setForm] = useState<SmtpConfig>({ host: '', port: 587, secure: false, username: '', password: '', from_address: '', from_name: '' });
  const [message, setMessage] = useState<{ kind: 'ok' | 'err'; text: string } | null>(null);
  const [busy, setBusy] = useState(false);
  const [configured, setConfigured] = useState(false);

  useEffect(() => {
    integrationApi.list().then((r) => {
      if (r.integrations.find((i) => i.kind === 'smtp')) setConfigured(true);
    }).catch(() => null);
  }, []);

  const save = async () => {
    setBusy(true); setMessage(null);
    try {
      await integrationApi.saveSmtp(form);
      setMessage({ kind: 'ok', text: 'Saved.' });
      setConfigured(true);
    } catch (err) {
      setMessage({ kind: 'err', text: (err as Error).message });
    } finally { setBusy(false); }
  };
  const test = async () => {
    setBusy(true); setMessage(null);
    try {
      await integrationApi.testSmtp();
      setMessage({ kind: 'ok', text: 'Test email sent.' });
    } catch (err) {
      setMessage({ kind: 'err', text: (err as Error).message });
    } finally { setBusy(false); }
  };

  return (
    <div style={{ maxWidth: 640 }} className="stack">
      <h1>Email (SMTP)</h1>
      <p className="muted">
        Litigate sends invoices and notifications via your own SMTP server. Configure any provider — Microsoft 365, Google Workspace, Mailgun, SES, your own relay.
      </p>
      <div className="card stack">
        <div className="row">
          <div className="grow">
            <label>Host</label>
            <input value={form.host} onChange={(e) => setForm({ ...form, host: e.target.value })} placeholder="smtp.example.com" />
          </div>
          <div style={{ width: 120 }}>
            <label>Port</label>
            <input type="number" value={form.port} onChange={(e) => setForm({ ...form, port: Number(e.target.value) })} />
          </div>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input type="checkbox" checked={!!form.secure} onChange={(e) => setForm({ ...form, secure: e.target.checked })} style={{ width: 'auto' }} />
          <span>Use TLS (secure)</span>
        </label>
        <div className="row">
          <div className="grow">
            <label>Username</label>
            <input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} />
          </div>
          <div className="grow">
            <label>Password</label>
            <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
        </div>
        <div className="row">
          <div className="grow">
            <label>From name</label>
            <input value={form.from_name} onChange={(e) => setForm({ ...form, from_name: e.target.value })} placeholder="Adv. Jane Doe" />
          </div>
          <div className="grow">
            <label>From address</label>
            <input type="email" value={form.from_address} onChange={(e) => setForm({ ...form, from_address: e.target.value })} placeholder="jane@chambers.example" />
          </div>
        </div>
        {message && (
          <div style={{ color: message.kind === 'ok' ? 'var(--color-success)' : 'var(--color-danger)' }}>{message.text}</div>
        )}
        <div className="row">
          <button className="primary" onClick={save} disabled={busy}>Save</button>
          {configured && <button onClick={test} disabled={busy}>Send test email</button>}
        </div>
      </div>
    </div>
  );
}
